import { SVGProps } from "react";

export default function BlockQuoteIcon(props: SVGProps<SVGSVGElement>) {
  const { height = 13, width = 12, stroke = "#292D32", ...rest } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M10.9947 6.32281H8.09469C7.32969 6.32281 6.80469 5.74281 6.80469 5.03281V3.42279C6.80469 2.71279 7.32969 2.13281 8.09469 2.13281H9.70469C10.4147 2.13281 10.9947 2.71279 10.9947 3.42279V6.32281Z"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.9916 6.32031C10.9916 9.34531 10.4266 9.84529 8.72656 10.8553"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.18219 6.32281H2.28219C1.51719 6.32281 0.992188 5.74281 0.992188 5.03281V3.42279C0.992188 2.71279 1.51719 2.13281 2.28219 2.13281H3.89719C4.60719 2.13281 5.18719 2.71279 5.18719 3.42279V6.32281"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.17906 6.32031C5.17906 9.34531 4.61406 9.84529 2.91406 10.8553"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
